import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Retailer } from "../../models/retailer.model";

@Injectable()
export class RetailerProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Retailer> {
    return this.http
      .get<Retailer>(`${this.url}/retailers/${id}`)
      .map(response => {
        return new Retailer(response);
      })
      .catch(this.handleError)
  }

  getAllByCountryID(countryID: number): Observable<Retailer[]> {
    return this.http
      .get<Retailer[]>(`${this.url}/retailers/country/${countryID}`)
      .map(response => {
        return response.map((retailer) => new Retailer(retailer));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/retailer/retailer.ts